import { GridSize } from '@material-ui/core';

const featuresPerRowService = {
  getFeaturesPerRow: (value: string) => {
    const gridSize = 12 / Number(value);

    if (!isNaN(Number(value))) {
      return gridSize as boolean | GridSize;
    }
    if (value === 'multiple') {
      value = 'auto';

      return value as boolean | GridSize;
    }

    return value as boolean | GridSize;
  },
};

export default featuresPerRowService;
